import React from "react";
import { useSelector } from "react-redux";
import { Route, Switch, useRouteMatch } from "react-router-dom";

import { AppState } from "../../../store";

import { RecipeEditor } from "./RecipeEditor";
import { RecipeList } from "./RecipeList";
import { SourceList } from "./SourceList";

export const RecipeManager: React.FC = () => {
  const { isCoeffAdmin } = useSelector(({ app }: AppState) => ({
    isCoeffAdmin: app.isCoeffAdmin,
  }));
  const { path } = useRouteMatch();

  if (!isCoeffAdmin) {
    return <div>Unauthorized</div>;
  }

  return (
    <Switch>
      <Route exact path={path} component={SourceList} />
      <Route exact path={`${path}/:source`} component={RecipeList} />
      <Route path={`${path}/:source/:recipeId`} component={RecipeEditor} />
    </Switch>
  );
};
